<template>
  <div>
    <VCreditCard :trans="translations" @change="creditInfoChanged" />

    <vs-button
      class="w-full"
      :disabled="carregando"
      block
      type="gradient"
      icon-pack="feather"
      icon="icon-check"
      icon-before
      size="large"
      color="success"
      @click="adicionar"
    >
      <span>{{ textoBotao ? textoBotao : 'Adicionar Cartão' }}</span>
    </vs-button>
  </div>
</template>
<!-- eslint-disable -->
<script>
import VCreditCard from 'v-credit-card';
import 'v-credit-card/dist/VCreditCard.css';
import service from '../../services';
const translations = {
  name: {
    label: 'Nome',
    placeholder: 'Nome completo',
  },
  card: {
    label: 'Número do Cartão',
    placeholder: 'Número do Cartão',
  },
  expiration: {
    label: 'Expiração',
  },
  security: {
    label: 'Código de segurança',
    placeholder: 'Código',
  },
};

export default {
  data() {
    return {
      carregando: false,
      translations,
      name: '',
      cardNumber: '',
      expiration: '',
      security: '',
    };
  },
  props: ['idProspect', 'idEmpresa', 'idProposta', 'typeCard', 'textoBotao'],
  methods: {
    creditInfoChanged(values) {
      for (const key in values) {
        this[key] = values[key];
      }
    },
    adicionarCartao(obj) {
      obj = {
        ...obj,
        idProspect: this.idProspect,
        idEmpresa: this.idEmpresa,
        idProposta: this.idProposta,
        tipoCartao: this.typeCard,
      };

      this.carregando = true;
      service
        .post('CotacaoAberta', 'AdicionarCartao', obj)
        .then((res) => {
          this.carregando = false;
          this.$emit('adicionar', {
            name: this.name,
            cardNumber: res.data.number,
            expiration: this.expiration,
            security: this.security,
            bandeira: res.data.Brand.name,
            selecionado: this.typeCard == 'Mensalidade' ? true : false,
            selecionadoAdesao: this.typeCard != 'Mensalidade' ? true : false,
            idCartao: res.data.myId,
            tipoCartao: this.typeCard,
          });
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Falha ao adicionar o cartão! <br>' + e,
            color: 'warning',
          });

          this.carregando = false;
        });
    },
    adicionar() {
      var msg = [];
      if (this.name == '') {
        msg.push('Preencha o Nome Completo. <br>');
      }

      if (this.cardNumber == '') {
        msg.push('Preencha o número do Cartão. <br>');
      } else {
        if (this.cardNumber.length != 19) {
          msg.push('Preencha o número do Cartão Completo. <br>');
        }
      }

      if (this.expiration == '') {
        msg.push('Preencha o vencimento do Cartão. <br>');
      } else {
        if (this.expiration.length != 5) {
          msg.push('Preencha o vencimento do Cartão MM/YY. <br>');
        }
      }

      if (this.security == '') {
        msg.push('Preencha o código de segurança do Cartão. <br>');
      } else {
        if (this.security < 3) {
          msg.push(
            'Preencha o código de segurança do Cartão corretamente. <br>',
          );
        }
      }

      if (msg.length > 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: msg.join(' '),
          color: 'warning',
        });
        return;
      } else {
        this.adicionarCartao({
          name: this.name,
          idEmpresa: this.idEmpresa,
          idProposta: this.idProposta,
          cardNumber: this.cardNumber,
          expiration: this.expiration,
          security: this.security,
          selecionado: true,
        });
      }
    },
  },
  components: {
    VCreditCard,
  },
};
</script>
